import 'css-chunksrc/client/common/layout/zonesList/zone/styles.scss';export default {
  "zone": "_zone_c5fc1_1",
  "header": "_header_c5fc1_5",
  "icon": "_icon_c5fc1_14",
  "avatar": "_avatar_c5fc1_22",
  "mainHeader": "_mainHeader_c5fc1_29",
  "mainTitle": "_mainTitle_c5fc1_37",
  "name": "_name_c5fc1_43",
  "projectCount": "_projectCount_c5fc1_63",
  "addProjectButton": "_addProjectButton_c5fc1_78",
  "addProjectButtonIcon": "_addProjectButtonIcon_c5fc1_85",
  "projectsList": "_projectsList_c5fc1_95",
  "opened": "_opened_c5fc1_99",
  "selected": "_selected_c5fc1_103",
  "sidebarClosed": "_sidebarClosed_c5fc1_108",
  "loader": "_loader_c5fc1_133",
  "loaderMain": "_loaderMain_c5fc1_141",
  "noProjectFound": "_noProjectFound_c5fc1_148"
};